import { formatPlayerEsnDisplay, playerEsnToken, type TPlayerEsnDisplayInput } from '@lucimark/shared/helpers/playerEsnDisplay'

/** Directory / registration id prefix — never uses live ANDROID_ID. */
export function playerRegistrationIdPrefix(playerId: string): string | null {
  const id = typeof playerId === 'string' ? playerId.trim() : ''
  if (id === '') {
    return null
  }
  if (id.includes('-')) {
    return id.split('-')[0] ?? id
  }
  return id.length >= 8 ? id.slice(0, 8) : id
}

export type TPlayerEsnDrift = {
  drifted: boolean
  registrationPrefix: string | null
  devicePrefix: string | null
  displayEsn: string | null
}

export function resolvePlayerEsnDrift(input: TPlayerEsnDisplayInput): TPlayerEsnDrift {
  const plat = (input.platform ?? '').toLowerCase()
  const registrationPrefix = playerRegistrationIdPrefix(input.playerId)
  const devicePrefixRaw = typeof input.androidIdPrefix === 'string' ? input.androidIdPrefix.trim() : ''
  const devicePrefix = devicePrefixRaw !== '' ? devicePrefixRaw : null
  const displayEsn = playerEsnToken(input)

  if (plat !== 'android' || devicePrefix == null || registrationPrefix == null) {
    return { drifted: false, registrationPrefix, devicePrefix, displayEsn }
  }

  const drifted = registrationPrefix.toLowerCase() !== devicePrefix.toLowerCase()
  return { drifted, registrationPrefix, devicePrefix, displayEsn }
}

/** On-device overlay: show device prefix plus registration prefix when they diverge. */
export function formatPlayerEsnOverlayDisplay(input: TPlayerEsnDisplayInput): string {
  const drift = resolvePlayerEsnDrift(input)
  if (!drift.drifted || drift.devicePrefix == null || drift.registrationPrefix == null) {
    return formatPlayerEsnDisplay(input)
  }
  return `#${drift.devicePrefix} · reg #${drift.registrationPrefix}`
}
